import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  CircularProgress,
  Grid,
  Card,
  CardActionArea,
  CardContent,
  Avatar,
} from "@mui/material";
import { LocationOn } from "@mui/icons-material";
import { FormDatas } from "../../types/FormData";
import { fetchPublicFranchiseLocations } from "../../services/public.services";

interface LocationSelectionProps {
  formData: FormDatas;
  setFormData: (data: FormDatas) => void;
}

const LocationSelection: React.FC<LocationSelectionProps> = ({ formData, setFormData }) => {
  const [locations, setLocations] = useState<{ id: number; name: string }[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchLocations = async () => {
      try {
        const response = await fetchPublicFranchiseLocations();
        console.log(response);
        const allLocations = response.franchises[0]?.locations || [];
        setLocations(allLocations);
      } catch (err) {
        console.log(err);
        setError("Fehler beim Laden der Standorte.");
      } finally {
        setLoading(false);
      }
    };

    fetchLocations();
  }, []);

  const handleSelect = (locationName: string, locationId: number) => {
    setFormData({
      ...formData,
      location: locationName,
      locationId: locationId,
    });
  };

  return (
    <Box sx={{ textAlign: "center", mt: 4 }}>
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1 }}>
        <LocationOn sx={{ fontSize: "28px", color: "primary.main" }} />
        <Typography variant="h1" sx={{ fontWeight: "bold", color: "primary.main" }}>
          Standort auswählen
        </Typography>
      </Box>

      {loading ? (
        <Box sx={{ textAlign: "center", mt: 3 }}>
          <CircularProgress />
        </Box>
      ) : error ? (
        <Typography color="error">{error}</Typography>
      ) : (
        <Grid container spacing={1} justifyContent="center" sx={{ mt: 3, maxWidth: 750, margin: "0 auto" }}>
          {locations.map((location) => (
            <Grid item key={location.id} xs={6} sm={4} md={2}>
              <Card
                onClick={() => handleSelect(location.name, location.id)}
                sx={{
                  border: formData.locationId === location.id ? "2px solid #1976d2" : "1px solid #ddd",
                  background: formData.locationId === location.id ? "#e3f2fd" : "#ffffff",
                  borderRadius: "8px",
                  transition: "all 0.3s ease-in-out",
                  textAlign: "center",
                  padding: 1,
                  cursor: "pointer",
                  width: "100px", // Kleinere Breite
                  height: "100px", // Kleinere Höhe
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center"
                }}
              >
                <CardActionArea>
                  <CardContent sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                    <Avatar sx={{ bgcolor: "#1976d2", width: 30, height: 30 }}>
                      <LocationOn sx={{ color: "white", fontSize: "16px" }} />
                    </Avatar>
                    <Typography variant="body2" sx={{ fontWeight: "bold", color: "#37474f", fontSize: "0.8rem", mt: 0.5 }}>
                      {location.name}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
};

export default LocationSelection;